import * as querystring from 'querystring';

export class ResultPageHandler {

    private static instance: ResultPageHandler;

    public static getInstance(): ResultPageHandler {
        if (!ResultPageHandler.instance) {
            ResultPageHandler.instance = new ResultPageHandler();
        }
        return ResultPageHandler.instance;
    }

    public handleButtonCallback(history: any, data: object | undefined) {
        console.log("[ResultPageHandler][handleButtonCallback] call callback for result page!");
        if (data !== undefined) {
            console.log("[ResultPageHandler][handleButtonCallback] data is populated!");
            // @ts-ignore
            let from = data.from;
            if (from !== undefined && from === "ChangePassword") {
                console.log("[ResultPageHandler][handleButtonCallback] change password callback!");
                this.changePasswordCallback(history, data);
            } else if (from !== undefined && from === "UserDetails") {
                console.log("[ResultPageHandler][handleButtonCallback] user details!");
                //@ts-ignore
                let operation = data.operation;
                if (operation === "revokeUser") {
                    console.log("[ResultPageHandler][handleButtonCallback] Revoke user!");
                    window.history.pushState(null, '', '/');
                    history.push('/users');
                } else if (operation === "resetPwd") {
                    console.log("[ResultPageHandler][handleButtonCallback] Reset PWD!");
                    window.history.pushState(null, '', '/');
                    history.push('/users');
                }
            } else if (from !== undefined && from === "ChooseTerminal") {
                console.log("[ResultPageHandler][handleButtonCallback] add user callback");
                window.history.pushState(null, '', '/');
                history.push('/users');
            } else if (from !== undefined && from === "MobileSearchOverlay") {
                console.log("[ResultPageHandler][handleButtonCallback] add user callback from MobileSearchOverlay");
                window.history.pushState(null, '', '/');
                history.push('/users');
            } else if (from !== undefined && from === "CatalogPage") {
                window.history.pushState(null, '', '/');
                history.push('/catalog');
            } else if (from !== undefined && from === "ChooseProductCategories") {
                //@ts-ignore
                let operation = data.operation;
                if (operation === "addProduct") {
                    window.history.pushState(null, '', '/');
                    history.push('/catalog');
                    history.push('/addProduct/first')
                } else if (operation === "updateProduct") {
                    //@ts-ignore
                    let product = data.product;
                    history.push('/catalog');
                    let hasImage = (product.image === null || product.image === undefined) ? false : (product.image === "") ? false : true;
                    let queryParams = { name: product.name !== null ? encodeURIComponent(product.name) : "", hasImage: hasImage };
                    let link = `/products/${product.productId}?${querystring.stringify(queryParams)}`;
                    history.push(link, { image: product.image, type: product.imageType });
                }
            } else if (from !== undefined && from === "InsertProductDetails") {
                //@ts-ignore
                let operation = data.operation;
                if (operation === "updateProduct") {
                    //@ts-ignore
                    let product = data.product;
                    history.push('/catalog');
                    let hasImage = (product.image === null || product.image === undefined) ? false : (product.image === "") ? false : true;
                    let queryParams = { name: product.name !== null ? encodeURIComponent(product.name) : "", hasImage: hasImage };
                    let link = `/products/${product.productId}?${querystring.stringify(queryParams)}`;
                    history.push(link, { image: product.image, type: product.imageType });
                }
            } else if (from !== undefined && from === "CategoryDetailsPage") {
                window.history.pushState(null, '', '/');
                history.push('/catalog');
            } else if (from !== undefined && from === "MultiproductPage") {
                //@ts-ignore
                let operation = data.operation;
                if (operation === "uploadFileSuccess") {
                    window.history.pushState(null, '', '/');
                    history.push('/catalog');
                    history.push('/addProduct/first')
                } else {
                    window.history.pushState(null, '', '/');
                    history.push('/catalog');
                }
            } else if (from !== undefined && 'Applications') {
                window.history.pushState(null, '', '/');
                history.push('/applications');
            }
        }
    }

    private changePasswordCallback(history: any, data: object) {
        //@ts-ignore
        if (data.result) {
            //@ts-ignore
            if (data.showTC) {
                console.log("[ResultPageHandler][ChangePassword] showing T&C...");
                history.push('/termsAndConditions', { fromHome: false });
            } else {
                console.log("[ResultPageHandler][ChangePassword] go to Home Page...");
                history.push('/login');
            }
        } else {
            //@ts-ignore
            if (data.sessionExpired) {
                history.push('/login');
            } else {
                history.replace('/changePassword');
            }
        }
    }
}